import { cn } from '@/lib/utils';

type WordmarkProps = {
    className?: string;
};

export default function Wordmark({ className }: WordmarkProps) {
    return (
        <div className={cn('fc-wordmark', className)} aria-label="Fate City">
            <span className="fc-wordmark-fate">FATE</span>
            <span className="fc-wordmark-city"><i /><b>CITY</b></span>
        </div>
    );
}
